import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const Box = styled.div`
  width: 80%;
  margin: 1.5rem 10%;
  color: #000;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: 300;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class Header extends Component {
  render() {
    const { color, str, ...props } = this.props

    return (
      <Box color={color} {...props}>
        <Text str={str} />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js